import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import resourcesSettings from 'settings/resources'

const {
  resources,
} = resourcesSettings

const useStyles = makeStyles(theme => ({
  
}))

const ResourceIcon = ({
  className,
  type,
}) => {

  const resource = resources[type] || resources.misc
  const Icon = resource.icon

  return (
    <Icon
      className={ className }
    />
  )
}

export default ResourceIcon

